import { ErrorEvent } from '@/services/analytics/events';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

@Component({
  name: 'CmgGlobalErrorToastModal',
})
export default class CmgGlobalErrorToastModal extends Vue {

  get visible(): boolean {
    return this.$appStore.state.ui.modals.globalErrorToast.visible;
  }

  get mobileToastWidth(): string {
    return this.$appStore.state.ui.clientWidth < 450 ? '300px' : '350px';
  }

  @Watch('visible', { immediate: false })
  onVisibleChanged(newVisible: boolean) {
    if (newVisible === true) {
      this.$services.analytics.send(new ErrorEvent('account', `Sorry. Something's not right. Please try again later.`, 'global-error-toast'));
      setTimeout(() => {
        if (this.visible) {
          this.$services.ui.setModalVisibility('globalErrorToast', false);
        }
      }, 5000);
    }
  }

  onCancel() {
    this.$services.ui.setModalVisibility('globalErrorToast', false);
  }
}
